// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  AgentTypeConfigInputOption,
  AgentTypeConfigInputOptionFromJSON,
  AgentTypeConfigInputOptionToJSON,
} from "./";

/**
 *
 * @export
 * @interface AgentTypeConfigInput
 */
export interface AgentTypeConfigInput {
  /**
   * Key this input occupies in the agent's config object
   * @type {string}
   * @memberof AgentTypeConfigInput
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof AgentTypeConfigInput
   */
  label: string;
  /**
   *
   * @type {string}
   * @memberof AgentTypeConfigInput
   */
  type: AgentTypeConfigInputTypeEnum;
  /**
   *
   * @type {boolean}
   * @memberof AgentTypeConfigInput
   */
  required?: boolean;
  /**
   *
   * @type {string}
   * @memberof AgentTypeConfigInput
   */
  help?: string;
  /**
   * Prefilled value, editable by the user
   * @type {string}
   * @memberof AgentTypeConfigInput
   */
  defaultValue?: string;
  /**
   * Only set when type is entity_ref
   * @type {string}
   * @memberof AgentTypeConfigInput
   */
  entity?: AgentTypeConfigInputEntityEnum;
  /**
   * Applies to select and entity_ref
   * @type {boolean}
   * @memberof AgentTypeConfigInput
   */
  multiple?: boolean;
  /**
   * Only set when type is select
   * @type {Array<AgentTypeConfigInputOption>}
   * @memberof AgentTypeConfigInput
   */
  options?: Array<AgentTypeConfigInputOption>;
}

export function AgentTypeConfigInputFromJSON(json: any): AgentTypeConfigInput {
  return {
    name: json["name"],
    label: json["label"],
    type: json["type"],
    required: !exists(json, "required") ? undefined : json["required"],
    help: !exists(json, "help") ? undefined : json["help"],
    defaultValue: !exists(json, "default_value")
      ? undefined
      : json["default_value"],
    entity: !exists(json, "entity") ? undefined : json["entity"],
    multiple: !exists(json, "multiple") ? undefined : json["multiple"],
    options: !exists(json, "options")
      ? undefined
      : (json["options"] as Array<any>).map(AgentTypeConfigInputOptionFromJSON),
  };
}

export function AgentTypeConfigInputToJSON(value?: AgentTypeConfigInput): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    name: value.name,
    label: value.label,
    type: value.type,
    required: value.required,
    help: value.help,
    default_value: value.defaultValue,
    entity: value.entity,
    multiple: value.multiple,
    options:
      value.options === undefined
        ? undefined
        : (value.options as Array<any>).map(AgentTypeConfigInputOptionToJSON),
  };
}

/**
 * @export
 * @enum {string}
 */
export enum AgentTypeConfigInputTypeEnum {
  Text = "text",
  Textarea = "textarea",
  Url = "url",
  Number = "number",
  Boolean = "boolean",
  Select = "select",
  SecretRef = "secret_ref",
  EntityRef = "entity_ref",
}
/**
 * @export
 * @enum {string}
 */
export enum AgentTypeConfigInputEntityEnum {
  Suite = "suite",
  Testplan = "testplan",
  Linkedrepository = "linkedrepository",
  User = "user",
}
